import { AxiosInstance } from 'axios';

import { BaseAuthenticatedClient } from '.';
import { BaseDataResponse, BaseResponse } from '../responses';
import { PriceListItemModel } from '../interfaces';
import { IAuthenticatedRequestHandler, IErrorHandler } from '../abstractions';

export default class PriceListItemClient extends BaseAuthenticatedClient {
  constructor(authenticatedRequestHandler: IAuthenticatedRequestHandler, errorHandler: IErrorHandler, axiosInstance: AxiosInstance) {
    super(authenticatedRequestHandler, errorHandler, axiosInstance, 'pricelistitem');
  }

  public async getAllAsync(): Promise<BaseDataResponse<PriceListItemModel[]>> {
    return await this.getHttpAsync<BaseDataResponse<PriceListItemModel[]>>('', '');
  }

  public async createAsync(model: PriceListItemModel): Promise<BaseDataResponse<PriceListItemModel>> {
    return await this.postHttpAsync<BaseDataResponse<PriceListItemModel>, PriceListItemModel>('', model);
  }

  public async updateAsync(model: PriceListItemModel): Promise<BaseDataResponse<PriceListItemModel>> {
    return await this.putHttpAsync<BaseDataResponse<PriceListItemModel>, PriceListItemModel>(`${model.id}`, model);
  }

  public async deleteAsync(id: number): Promise<BaseResponse> {
    return await this.deleteHttpAsync<BaseResponse>(`${id}`);
  }
}
